"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _options = require("@module/options");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _profile = require("@widget/profile");

var _utils = require("@package/utils");

var _dialog = require("@package/dialog");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Security = _interopRequireDefault(require("./Security"));

var _Employees = _interopRequireDefault(require("./Employees"));

var _Identification = _interopRequireDefault(require("./Identification"));

var _LegalInfo = _interopRequireDefault(require("./LegalInfo"));

var _ChangeEmailDialog = _interopRequireDefault(require("./ChangeEmailDialog"));

var _ConfirmCodeDialog = _interopRequireDefault(require("./ConfirmCodeDialog"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function OptionsCommand() {
  try {
    var onShowDialogByType = function onShowDialogByType(type) {
      dispatch((0, _dialog.openDialog)(type));
    };

    var onChangeEmail = function onChangeEmail(data) {
      dispatch((0, _options.changeEmail)(data));
    };

    var onInitConfirmEmail = function onInitConfirmEmail() {
      dispatch((0, _options.initialConfirmEmail)());
    };

    var onConfirmEmail = function onConfirmEmail(data) {
      dispatch((0, _options.confirmEmail)(data));
    };

    var handleEditUser = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(id) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch((0, _dialog.openDialog)('update-user', {
                  id: id
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleEditUser(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var handleRemoveUser = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(id) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch((0, _options.removeUserDataById)(id));

              case 2:
                dispatch((0, _dialog.closeDialog)("remove-confirm-" + id));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleRemoveUser(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleUpdateLegal = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(data) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch((0, _options.updateLegal)(data));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function handleUpdateLegal(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    var dispatch = (0, _reactRedux.useDispatch)();
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var user = (0, _reactRedux.useSelector)(_options.selectUser);
    var users = (0, _reactRedux.useSelector)(_options.selectUsers);
    var identification = (0, _reactRedux.useSelector)(_options.selectIdentificationData);
    var inProcess = (0, _reactRedux.useSelector)(_options.selectInProcess);
    var identificationInProcess = (0, _reactRedux.useSelector)(_options.selectIdentificationInProcess);
    var isUserSelfUpdatePermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'user.selfupdate');
    var isUserUpdatePermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'user.update');
    var isIdentificationPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'merchant.identification.get');
    var isShowLegalInfo = profile.merchant.type && ['LEGAL', 'ST'].indexOf(profile.merchant.type) !== -1 && profile.merchant.status && profile.merchant.status.type !== 'Moderated';
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: 'page'
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: 'page__content'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2,
      "data-locator": 'Settings.header'
    }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, isShowLegalInfo && /*#__PURE__*/_react["default"].createElement(_LegalInfo["default"], {
      merchant: profile.merchant,
      inProcess: inProcess,
      onUpdateLegal: handleUpdateLegal
    }), /*#__PURE__*/_react["default"].createElement(_Security["default"], {
      editable: isUserSelfUpdatePermission,
      data: user,
      inProcess: inProcess,
      onChange: onShowDialogByType,
      onConfirm: onInitConfirmEmail
    }), profile['merchant']['type'] === 'INDIVIDUAL' && isIdentificationPermission && /*#__PURE__*/_react["default"].createElement(_Identification["default"], {
      data: identification,
      inProcess: identificationInProcess
    }), /*#__PURE__*/_react["default"].createElement(_Employees["default"], {
      users: users,
      isEditable: isUserUpdatePermission,
      onEdit: handleEditUser,
      onRemove: handleRemoveUser
    })))), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      name: "email.change",
      title: "\u0421\u043C\u0435\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u043F\u043E\u0447\u0442\u044B"
    }, /*#__PURE__*/_react["default"].createElement(_ChangeEmailDialog["default"], {
      data: user,
      onSubmit: onChangeEmail,
      inProcess: inProcess
    })), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      name: "email.confirm",
      title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0430\u0434\u0440\u0435\u0441\u0430 \u043F\u043E\u0447\u0442\u044B"
    }, /*#__PURE__*/_react["default"].createElement(_ConfirmCodeDialog["default"], {
      data: user,
      onSubmit: onConfirmEmail,
      inProcess: inProcess
    })), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      name: "email.exceeded"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['holder']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultModule["default"]['holder__icon'], 'icon-crose')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['holder__text']
    }, "\u0412\u044B\xA0\u0432\u0432\u0435\u043B\u0438 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437.", /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430", /*#__PURE__*/_react["default"].createElement("br", null), "\u0447\u0435\u0440\u0435\u0437 10\xA0\u043C\u0438\u043D\u0443\u0442"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: 'page'
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: 'page__content'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    }))));
  }
}

var _default = OptionsCommand;
exports["default"] = _default;